import React, { useState } from "react";
import { Link } from "react-router-dom";
import styled, { css } from "styled-components";
import { IrisColors } from "../../css/IRISColors";

export const Heading1 = styled.h1`
    font-family: Arial Narrow;
    font-size: 2.5rem;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    ${props => props.color && css`
        color: ${props.color || IrisColors.irisBlack}
    `}

    ${props => props.bold && css`
        font-weight: bold;
    `}

    ${props => props.center && css`
        text-align: center;
    `}
    scroll-margin-top: 5em;
`;

export const Heading2 = styled.h2`
    font-family: Arial Narrow;
    pointer-events: none;
    font-size: 2rem;
    margin-top: 1.6rem;
    margin-bottom: 0.2rem;
    ${props => props.color && css`
        color: ${props.color || IrisColors.irisBlack}
    `}

    ${props => props.bold && css`
        font-weight: bold;
    `}

    ${props => props.normal && css`
        font-weight: normal;
    `}

    ${props => props.center && css`
        text-align: center;
    `}
    scroll-margin-top: 5em;
`;

export const Heading3 = styled.h2`
    font-family: Arial Narrow;
    font-size: 2rem;
    margin-top: 1rem;
    margin-bottom: 1rem;
    ${props => props.color && css`
        color: ${props.color || IrisColors.irisBlack}
    `}

    ${props => props.bold && css`
        font-weight: 700;
    `}

    ${props => props.italic && css`
        font-style: italic;
    `}

    ${props => props.center && css`
        text-align: center;
    `}
    
`;

/**
 * Styled paragraph for report text
 * props: white (text color), bold (text weight), center (align)
 * */

export const CondensedReportText = styled.p`
    font-family: Arial Narrow;
    font-size: 18px;
    font-weight: 500;
    margin-block: 2px;
    padding-top: 0px;

    ${props => props.white && css`
        color: ${IrisColors.white};
    `}

    ${props => props.bold && css`
        font-weight: 700;
    `}

    ${props => props.center && css`
        text-align: center;
    `}
`;

export const ReportText = styled.p`
    font-family: Arial Narrow;
    font-size: 15px;
    font-weight: 500;
    margin-block: 0px;
    padding-top: 10px;

    ${props => props.white && css`
        color: ${IrisColors.white};
    `}

    ${props => props.bold && css`
        font-weight: 700;
    `}

    ${props => props.center && css`
        text-align: center;
    `}
`;

/**
 * Styled span properties for text
 * props: bold (font weight), blue (color)*/
export const TextSpan = styled.span`

    ${props => props.blue && css`
        color: ${IrisColors.irisLogoBlue};
    `}

    ${props => props.bold && css`
        font-weight: 700;
    `}
`;

/**
 * Styled anchor tag for external links
 * color defaults to IRIS logo blue unless specified
 * */
export const TextLink = styled.a`
    text-decoration: none;
    font-weight: 600;
    cursor: pointer;
    color: ${props => props.color ? props.color : IrisColors.irisLogoBlue};

    &:hover {
        color: ${IrisColors.irisLogoRed};
        text-decoration: none;
    }
`;

/**
 * Styled React Router Link component for site navigation
 * color defaults to IRIS logo blue unless specified
 * */
export const TextRouteLink = styled(Link)`
    text-decoration: none;
    font-weight: 600;
    cursor: pointer;
    color: ${props => props.color ? props.color : IrisColors.irisLogoBlue};

    &:hover {
        color: ${IrisColors.irisLogoRed};
        text-decoration: none;
    }

    &:visited {
        text-decoration: none;
    }
`;

export const IRISBlueDivider = styled.hr`
    height: 2px;
    width: 100%;
    background-color: ${IrisColors.secondaryBlue};
    margin-bottom: 10px;
`;

export const IRISLightGreyDivider = styled.hr`
    height: 2px;
    width: 100%;
    background-color: ${IrisColors.backgroundGrey};
    margin-bottom: 10px;
`;

/**
 * Styled button
 * props: active (boolean) - optional tos how active state*/
export const ReportButton = styled.button`
    padding-inline: 1em;
    padding-block: 0.5em;
    margin-inline: 0.5em;
    font-size: 1.2em;
    font-weight: 700;
    cursor: pointer;
    ${(props) => {
        if (props.active) {
            return css`
                color: ${IrisColors.white };
                background: ${IrisColors.irisLogoBlue};
                border: 2px solid ${IrisColors.irisLogoBlue};
            `
        } else {
            return css`
                color: ${IrisColors.irisLogoBlue};
                background: ${IrisColors.white};
                border: 2px solid ${IrisColors.irisLogoBlue};
            `
        }
    }}
    border-radius: 3px;

    &:hover {
        color: ${IrisColors.white};
        background: ${IrisColors.secondaryBlue};
        border: 2px solid ${IrisColors.secondaryBlue};
        text-decoration: none;
    }
`;